import SectionHeading from "@/components/base/SectionHeading";
import { evidenceTypes } from "@/mocks/evidenceTypes";

export default function EvidenceTypes() {
  return (
    <section id="evidence-types" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="Evidence types"
          title="证据按类型归档，找起来更快"
          description="同一条线索可能同时有截图和录音，这里按素材形态分开存放，并标注是否已核实来源。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {evidenceTypes.map((type) => (
            <article
              key={type.key}
              className="group rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 transition-colors hover:border-primary-300/60"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-300 text-xl">
                <i className={type.icon} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{type.name}</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-500">{type.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}